import { PencilIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const DashboardScheduleEditAvailabilityButton = ({
  onClick,
  variant = "icon",
}: {
  onClick: () => void;
  variant?: "icon" | "labeled";
}) => {
  const renderLabeled = () => (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="h-8 gap-1.5 px-2 text-xs font-medium text-slate-600 hover:text-slate-900"
    >
      <PencilIcon className="h-3.5 w-3.5" />
      Edit Availability
    </Button>
  );

  const renderIcon = () => (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={onClick}
            className="h-8 w-8 shrink-0 text-slate-500 hover:text-slate-700"
          >
            <PencilIcon className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Edit Availability</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );

  const render = () => (variant === "labeled" ? renderLabeled() : renderIcon());

  return render();
};
